import { render } from "./ModuliRrOrders.vue?vue&type=template&id=70c210b1"
import script from "./ModuliRrOrders.vue?vue&type=script&lang=js"
export * from "./ModuliRrOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__